import { useQuery, gql } from "@apollo/client";
import { useParams, useSearchParams } from "react-router-dom";
import TranslationWrapper from "./translationWrapper";
import NameTableTranslatable from "./nameTableTranslateable";
import ProductTranslationForm from "./productTranslationForm";
import { useEffect, useState } from "react";


import { GraphQLPagination } from "../common";
import { getQueryVariables } from "../../utils";


const GET_PRODUCTS = gql`
  query MyQuery($first: Int, $after: String, $last: Int, $before: String) {
    products(first: $first, after: $after, last: $last, before: $before) {
      edges {
        node {
          dbId
          name
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;


function ProductTranslation() {
  const { languageCode } = useParams<{ languageCode: string }>();
  const [productId, setProductId] = useState<number | null>(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();


  const { data, loading, error } = useQuery(GET_PRODUCTS, {
    variables: getQueryVariables(searchParams),
    notifyOnNetworkStatusChange: true,
  });

  const handleOpenForm = (id: number) => {
    setIsFormOpen(true);
    setProductId(id);
  };


  const handleCloseForm = () => setIsFormOpen(false);

  useEffect(() => {
    if (!searchParams.get("first") && !searchParams.get("last")) {
      setSearchParams({ first: "20" });
    }
  }, []);

  const products = data?.products?.edges || [];

  return (
    <TranslationWrapper>
      <>
        <NameTableTranslatable data={products} onOpenForm={handleOpenForm} />

        <GraphQLPagination
          edges={data?.products?.edges || []}
          pageInfo={data?.products?.pageInfo || {}}
        />

        {isFormOpen && (
          <ProductTranslationForm
            id={productId}
            isOpen={isFormOpen}
            onClose={handleCloseForm}
          />
        )}

      </>
    </TranslationWrapper>
  );
}

export default ProductTranslation;
